// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pECmd","col":"styles_col__2P3v9","actions":"styles_actions__1W3L-","conflict":"styles_conflict__2vzjW"};